/**
 * Company Interface for Autocomplete
 */
export interface ICompany {
  id: number;
  name: string;
  code?: string;
  isActive: boolean;
}

/**
 * Company Model Class
 */
export class Company implements ICompany {
  id: number;
  name: string;
  code?: string;
  isActive: boolean;

  constructor(data: ICompany) {
    this.id = data.id;
    this.name = data.name;
    this.code = data.code;
    this.isActive = data.isActive;
  }

  /**
   * Get display label for autocomplete
   */
  get label(): string {
    return this.code ? `${this.name} (${this.code})` : this.name;
  }
}
